import { render, staticRenderFns } from "./EditRatePlan.vue?vue&type=template&id=3b16b022&scoped=true&"
import script from "./EditRatePlan.vue?vue&type=script&lang=js&"
export * from "./EditRatePlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b16b022",
  null
  
)

export default component.exports